import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, ShieldAlert } from "lucide-react";

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-primary-50/30 py-12 px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>Adgang nægtet - Sehested Tømrerfirma ApS</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 rounded-2xl border border-primary-100 shadow-sm">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-600">
          <ShieldAlert className="h-8 w-8" />
        </div>
        <p className="text-6xl font-extrabold text-brand-600">403</p>
        <h1 className="font-display text-3xl font-bold text-primary-950">Adgang nægtet</h1>
        <p className="text-primary-600 text-sm leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side.
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 transition-all duration-200 w-full"
          >
            <Home className="h-4 w-4" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
